import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-stock-triage',
    templateUrl: './stock-triage.component.html',
    styleUrls: ['./stock-triage.component.scss']
})
export class StockTriage implements OnInit {
    constructor() {}

    ngOnInit() {}
}